import { Ics204RichTextView } from './Ics204Fields';
import { ICS204_SUBCARD } from './assignmentCardStyles';

const AssignmentCardSpecialInstructions = ({
  specialInstructions,
}: {
  specialInstructions: string;
}) => {
  return (
    <div className={ICS204_SUBCARD}>
      <div
        className="tw:p-2"
        data-testid="ics204-special-instructions"
      >
        <Ics204RichTextView value={specialInstructions} />
      </div>
    </div>
  );
};

export default AssignmentCardSpecialInstructions;
